module.exports = __webpack_public_path__ + "img/table.53d205a6.svg";